import Box from '@mui/material/Box'
import { useNavigate } from "react-router-dom"
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'

import { ROUTE_SEGMENTS, YEARS_FROM_RELEASE_OF_FEES_TO_NEXT } from '@/constants/general'

const StyledCard = styled(Card)(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.common.white,
    cursor: 'pointer',
    transition: 'border-color 0.3s, box-shadow 0.3s',
    boxShadow: 'none',
    borderRadius: 10,
    '&:hover': {
        backgroundColor: theme.palette.grey[100],
    },
    maxWidth: 200,
    flexGrow: 1,
}))

function YearlyFeeCollectionYears() {

    const navigate = useNavigate()

    return (
        <Box sx={{
            display: 'flex',
            gap: 1,
            flexWrap: 'wrap',
            px: 2.5
        }}>
             {YEARS_FROM_RELEASE_OF_FEES_TO_NEXT.map(year => (
                <StyledCard
                    key={year}
                    onClick={() => navigate(`/${ROUTE_SEGMENTS.base}/${ROUTE_SEGMENTS.municipalityManagement}/${ROUTE_SEGMENTS.yearlyFeeCollection}/${year}`)}
                >
                    <CardContent sx={{ pt: 3 }}>
                        <Box textAlign="center">
                            <CalendarMonthRoundedIcon fontSize='large' color='action' />
                            <Typography variant="h4" component="div" mt={1}>
                                {year.toString()}
                            </Typography>
                        </Box>
                    </CardContent>
                </StyledCard>
             ))}
        </Box>
    )
}

export default YearlyFeeCollectionYears
